export enum BeeType {
	DiesFirstBee = "DiesFirstBee", // Health bee
	BasicBee = "BasicBee",
	MeleeBee = "MeleeBee",
	DodgeBee = "DodgeBee",
	DashBee = "DashBee",
	BulletBee = "BulletBee",
	LaserBee = "LaserBee",
}
